import { render } from "./LandingPage.vue?vue&type=template&id=14563ae5"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=14563ae5&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script